import Repository from './Repository';

const CONTACT = '/contact-request';

export default {
	getSupport(obj) {
		return Repository.post(`${CONTACT}`, obj);
	},
};
